import * as React from 'react';
import cx from 'classnames';

import './Label.styles.scss';

export class Label extends React.Component {
    render() {
        const { text, className } = this.props;

        return <div className={cx('Label', className)}>{text || children}</div>;
    }
}